import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';

jest.mock('./usePricing', () => ({
  usePricing: () => ({
    loading: false,
    error: null,
    byApp: {
      slides: [{
        id: 'prod_slides',
        name: 'Slides',
        description: 'Slides plan',
        tiers: [{ id: 'price_slides', formatted: '$10/mo' }],
        features: ['Feature one', 'Feature two'],
      }],
      billboard: [{
        id: 'prod_billboard',
        name: 'Billboard',
        description: 'Billboard plan',
        tiers: [{ id: 'price_billboard', formatted: '$10/mo' }],
        features: ['Feature one', 'Feature two'],
      }],
    },
  }),
}));

jest.mock('../../../experiments/track', () => ({
  trackExperiment: jest.fn(),
}));

const mockUseExperiment = jest.fn();
jest.mock('../../../experiments/useExperiment', () => ({
  useExperiment: (...args) => mockUseExperiment(...args),
}));

import HomeControl from './HomeControl';
import { faqs } from './content';

beforeAll(() => {
  window.gtag = jest.fn();
});

describe('HomeControl', () => {
  beforeEach(() => {
    mockUseExperiment.mockReset();
    window.gtag.mockClear();
  });

  it('renders the control hero copy and not the treatment headline', () => {
    mockUseExperiment.mockReturnValue('control');
    render(<HomeControl />);

    expect(screen.getByRole('heading', {
      level: 1,
      name: /Collaborate and edit slides from anywhere/,
    })).toBeInTheDocument();

    expect(screen.queryByText(/Turn sermon notes into ProPresenter-ready slides/)).not.toBeInTheDocument();
    expect(screen.queryByAltText('WorshipKit Slides document review')).not.toBeInTheDocument();
  });

  it('renders the treatment hero headline and screenshot', () => {
    mockUseExperiment.mockReturnValue('treatment');
    render(<HomeControl />);

    expect(screen.getByRole('heading', {
      level: 1,
      name: /Turn sermon notes into ProPresenter-ready slides from any browser/,
    })).toBeInTheDocument();
    expect(screen.queryByRole('heading', {
      level: 1,
      name: /Collaborate and edit slides from anywhere/,
    })).not.toBeInTheDocument();

    expect(screen.getByAltText('WorshipKit Slides document review')).toBeInTheDocument();
  });

  it('renders all FAQ questions, the pricing badge, value anchor, and 30-day CTA copy', () => {
    mockUseExperiment.mockReturnValue('control');
    render(<HomeControl />);

    faqs.forEach((item) => {
      expect(screen.getByText(item.q)).toBeInTheDocument();
    });

    expect(screen.getAllByText('Most popular')).toHaveLength(1);
    expect(screen.getByText('Less than one ProPresenter license per month — no per-machine fees.')).toBeInTheDocument();
    expect(screen.getAllByText('Start 30-day free trial').length).toBeGreaterThan(0);
  });
});
